import { useCallback, useEffect, useState } from "react";
import MultiItemSelectDropdown from "../inputs/MultiItemSelectDropdown";
import SelectDropdown from "../inputs/SelectDropdown";
import AppContext from "../context/AppContext";
import { getDatePlus, getDeparturesUrl, getDestinationsUrl, getTravellers } from "../utils";
import FromToDateField from "../inputs/FromToDateField";

export default function EasyOTAFormFlight({ supplierId, onSubmit, supplierSettings }) {
   const [submitData, setSubmitData] = useState({});
   const [popupsListeners, setPopupsLisners] = useState([]);
   const [travellers, setTravellers] = useState({});
   const [departureList, setDepartureList] = useState([]);
   const [destinationList, setDestinationList] = useState([]);
   const [titleDefault, setTitleDefault] = useState();
   const travellersItems = getTravellers(supplierSettings);
   const popupCloseEvent = () => {
      popupsListeners.forEach((handler) => {
         handler();
      });
   };
   const registerPops = useCallback((handler) => {
      setPopupsLisners((prev) => {
         return [...prev, handler];
      });
   }, []);

   const handleOnChange = useCallback(({ name, value }) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            [name]: value,
         };
      });
   }, []);

   const handleOnChangeMult = useCallback((params) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            ...params,
         };
      });
   }, []);

   const handleSubmit = (ev) => {
      ev.preventDefault();
      console.log("Submit", submitData);
      onSubmit && onSubmit({ ...submitData, travellers });
   };

   useEffect(() => {
      let apiUrl = getDeparturesUrl(supplierId);
      const getDepartureList = async () => {
         let data = await (await fetch(apiUrl)).json();
         setDepartureList(data.map((i) => ({ ...i, name: `${i.name} (${i.airportCode})` })));
      };

      getDepartureList();
   }, [supplierId]);
   let locationVal = submitData["location"];
   useEffect(() => {
      if (locationVal) {
         let apiUrl = getDestinationsUrl(supplierId, locationVal.id);
         const getDestinationsList = async () => {
            let data = await (await fetch(apiUrl)).json();
            setDestinationList(
               data.filter((l) => l.id !== locationVal.id).map((i) => ({ ...i, name: `${i.name} (${i.airportCode})` }))
            );
         };
         getDestinationsList();
      }
   }, [locationVal, supplierId]);

   useEffect(() => {
      let title = document.title;
      // title = "Flights from Dar es Salaam T1 (DAR) to Ndutu Airport (NDT0) from $352 | Safarisoko";
      // title = "Flights from Dar es Salaam T2 (DAR) to Seronera (SEU) from $352 | Serengeti | Safarisoko";
      // title = "Flights from Pemba Island (PMA) to Zanzibar (ZNZ) | Safarisoko";
      // title = "Flights Arusha Airport (ARK) to Dar es Salaam T2 (DAR) from $175"
      // let parts = title.match(/^Flights from ([\w ]+) \(([\w]+)\) to ([\w ]+) \(([\w]+)\) \| /);
      let parts = title.match(/^Flights (?:from )?([\w ]+) \(([\w]+)\) to ([\w ]+) \(([\w]+)\)(?:\s+from\s+[\d$]+)?\s*(?:\||$)/);
      console.log({ title, parts });
      if (parts && parts.length && departureList.length && !titleDefault) {
         let fromCode = parts[2],
            toCode = parts[4];
         let fromFound = departureList.find((d) => {
           return d.airportCode === fromCode || d.airportCode.split('/').includes(fromCode);
         });
         let toFound = departureList.find((d) => {
           return d.airportCode === toCode || d.airportCode.split('/').includes(toCode);
         });

         setTitleDefault({ location: fromFound, destination: toFound });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [departureList]);

   useEffect(() => {
      if (titleDefault && !submitData["location"]) {
         let params = { ...submitData, ...titleDefault };
         setSubmitData(() => {
            return {
               ...params,
            };
         });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [titleDefault]);
   if (!departureList) return;

   return (
      <AppContext.Provider value={{ registerPopupListener: registerPops, popupCloseEvent }}>
         <div className='form'>
            <form action='#' method='post' id='search-form' onSubmit={handleSubmit} autoComplete='off'>
               <div className='fields'>
                  <SelectDropdown
                     field='location'
                     label='From'
                     hint='City or airport'
                     options={departureList}
                     onChange={handleOnChange}
                     defaultOption={titleDefault ? titleDefault["location"] : undefined}
                  />
                  <SelectDropdown
                     field='destination'
                     label='To'
                     hint='City or airport'
                     options={destinationList}
                     onChange={handleOnChange}
                     defaultOption={titleDefault ? titleDefault["destination"] : undefined}
                  />
                  <FromToDateField
                     params={{
                        from: {
                           field: "departure_date",
                           label: "Depart",
                        },
                        to: {
                           field: "return_date",
                           label: "Return",
                           placeholder: "Optional",
                        },
                     }}
                     minDate={getDatePlus(supplierSettings.minDaysToDeparture)}
                     required
                     onChange={handleOnChangeMult}
                     calendarPannels={2}
                  />
                  <MultiItemSelectDropdown
                     field='travellers'
                     label='Travellers'
                     items={travellersItems}
                     data={travellers}
                     settings={supplierSettings}
                     onChange={(selected) => {
                        setTravellers((prev) => {
                           return {
                              ...prev,
                              ...selected,
                           };
                        });
                     }}
                     required
                     validity='You must select atleast 1 adult'
                  />
               </div>
               <button className='btn'>Search</button>
            </form>
         </div>
      </AppContext.Provider>
   );
}
